import React, { Component } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent';
import { Link, Redirect, withRouter } from "react-router-dom";
import ApiSso from '../../actions/sso';
import { AppContext } from '../../AppContext';
import pack from '../../actions/pack';
import Api from "../../actions/api";

class Index extends Component {

    static contextType = AppContext;

    constructor(props){
        super(props);

        this.state = {
            plans: [],
            isLoading: true,
            step: 1,
            email: '',
            password: '',
            repeat_password: '',
            cpf: '',
            phone: '',
            error: '',
            status: false,
            read: false,
            validated: {},
            slideIndex: 0,
            updateCount: 0
        }

        this.checkIfUserExist = this.checkIfUserExist.bind(this);
    }

    componentDidMount(){

        this.auth().then(authResponse => {
            pack.getAllPackByClient(authResponse.data.data.token)
                .then((res) => {

                    console.log(res);

                    // Data
                    let resData = res.data.data;

                    // Procura parametros na URL
                    const search = this.props.location.search;
                    const pageId = new URLSearchParams(search).get("tag");

                    // Caso venha o parâmetro de ID na URL

                    if(pageId != null && resData.length > 1){
                        // Filtra o que vier da URL (id)
                        let filtered = resData.filter(function(item) {

                            if(item.tag == pageId){

                                console.log(item.value)

                                localStorage.setItem("user_plan_name", item.name);
                                localStorage.setItem("user_plan_price", item.value);
                                localStorage.setItem("user_plan_id", item.id);
                                localStorage.setItem("user_plan_tag", item.tag)

                            }

                            return item.id != pageId;
                        });

                        let selectObj = {
                            "id": localStorage.getItem("user_plan_id"),
                            "tag": localStorage.getItem("user_plan_tag"),
                            "name": localStorage.getItem("user_plan_name"),
                            "value": localStorage.getItem("user_plan_price")
                        }

                        const orderedPlans = [selectObj].concat(filtered);

                        this.setState({
                            plans: orderedPlans,
                            isLoading: false,
                        });

                    }else{

                        this.setState({
                            plans: resData,
                            isLoading: false,
                        });

                    }

                }).catch((err) => {
                    console.log(err)
                })

                const { setUserStep } = this.context;
                setUserStep(1);
        });

    }
    
    auth() {
        const client = process.env.REACT_APP_CLIENT;
        const key = process.env.REACT_APP_KEY;

        return ApiSso.post('client', {
            'client': client,
            'key': key
        });
    }

    checkIfUserExist(event){
        
        const { setUserStep } = this.context;
        const thisProps = this.props;

        event.preventDefault();

        this.setState({
            isLoading: true
        });

        const plan = document.getElementsByClassName("slick-current")[0].getElementsByClassName("plan")[0].innerHTML
        const plan_value = document.getElementsByClassName("slick-current")[0].getElementsByClassName("value")[0].innerHTML
        const plan_id = document.getElementsByClassName("slick-current")[0].getElementsByClassName("id")[0].innerHTML

        this.auth().then(authResponse => {
            ApiSso.defaults.headers.common['Authorization'] = authResponse.data.data.token;
            ApiSso.put('user/check', {
                'email': this.state.email
            }).then(response => {
                this.setState({isLoading: false});

                if (!response.data.data.exist) {

                    // Caso não encontre o e-mail do usuário

                    setUserStep(2)
                    localStorage.setItem('user_email', this.state.email);
                    localStorage.setItem("user_plan_name", plan)
                    localStorage.setItem("user_plan_price", plan_value)
                    localStorage.setItem("user_plan_id", plan_id)
                    localStorage.setItem("is_register", "true")

                } else {

                    // E-mail válido

                    setUserStep(2)
                    localStorage.setItem('user_email', this.state.email);
                    localStorage.setItem("user_plan_name", plan)
                    localStorage.setItem("user_plan_price", plan_value)
                    localStorage.setItem("user_plan_id", plan_id)
                    localStorage.setItem("is_register", "false")

                }

                window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                window.dataLayer.push({
                    'event': 'productClick',
                    'ecommerce': {
                    'click': {
                        'actionField': {'list': 'Search Results'},      // Optional list property.
                        'products': [{
                        'name': plan,                      // Name or ID is required.
                        'id': plan_id,
                        'price': plan_value,
                        }]
                    }
                    },
                    'eventCallback': function() {
                            
                        if (!response.data.data.exist) {
                            console.log('cadastro')
                            thisProps.history.push('/register')
                        }else{
                            console.log('login')
                            thisProps.history.push('/login')
                        }
                    }
                });

            }).catch(error => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
            });
        })

    }
    
    render(){


        const sliderSettings = {
            className: "center",
            centerMode: true,
            infinite: true,
            centerPadding: "150px",
            slidesToShow: 1,
            initialSlide: 0,
            speed: 500,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 540,
                    settings: {
                        centerPadding: "30px",
                    }
                }
            ],
        }

        

        return (
            <div className="page-container page">

                
                {/* <Steps step={this.state.step} /> */}

                <div className="position-relative">

                    {this.state.isLoading ? (
                        <LoadingComponent />
                    ) : (
                        this.state.plans !== undefined ? (

                        <div className="pt-5">
                            {this.state.plans.length > 1 ? (

                            <Slider ref={slider => (this.slider = slider)} {...sliderSettings}>
                                {this.state.plans.map((plan) => {
                                    return (
                                        <div key={plan}>
                                            <div className='slick-plan'>
                                                <small></small>
                                                <h2>
                                                    <span className="id">{plan.id}</span>
                                                    <span className="plan">{plan.name}</span> - R$
                                                    <span className="value">{plan.value.toLocaleString('pt-br', {minimumFractionDigits: 2}).substring(0,5)}</span></h2>
                                            </div>
                                        </div>
                                    )
                                })}
                            </Slider>

                            ) : (

                                <Slider ref={slider => (this.slider = slider)} {...sliderSettings}>
                                    <div>
                                        <div className='slick-plan'>
                                            <small></small>
                                            <h2>
                                                <span className="id">{this.state.plans[0].id}</span>
                                                <span className="plan">{this.state.plans[0].name}</span> - R$
                                                <span className="value">{this.state.plans[0].value.toLocaleString('pt-br', {minimumFractionDigits: 2}).substring(0,5)}</span></h2>
                                        </div>
                                    </div>
                                </Slider>

                            )}
                        </div>

                        ) : (
                            <div className="py-5 text-center">
                                <p>Os planos não carregaram corretamente.</p>
                                <small>Atualize a página</small>        
                            </div>
                        )
                    )}

                    <div className="p-5 pt-3">
                        <form onSubmit={event => this.checkIfUserExist(event)} className="text-center form login-form">
                            <h4>Para continuarmos, digite seu e-mail</h4>
                            <input type="email" className="form-control" value={this.state.email} onChange={(e) => {this.setState({email: e.target.value})}} placeholder="Digite seu e-mail" /><br />
                            <input type="submit" className="form-submit" value="Continuar" />
                        </form>
                    </div>
                    
                
                </div>
            </div>
        )
    }
}

export default withRouter(Index);